/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateServiceVo } from './CommissionRateServiceVo';
import {
    CommissionRateServiceVoFromJSON,
    CommissionRateServiceVoFromJSONTyped,
    CommissionRateServiceVoToJSON,
    CommissionRateServiceVoToJSONTyped,
} from './CommissionRateServiceVo';
import type { OrderItemVo1 } from './OrderItemVo1';
import {
    OrderItemVo1FromJSON,
    OrderItemVo1FromJSONTyped,
    OrderItemVo1ToJSON,
    OrderItemVo1ToJSONTyped,
} from './OrderItemVo1';

/**
 * 
 * @export
 * @interface RecommendCodeBindDetailRespVo
 */
export interface RecommendCodeBindDetailRespVo {
    /**
     * 邀新会员id
     * @type {number}
     * @memberof RecommendCodeBindDetailRespVo
     */
    userId?: number;
    /**
     * 表头附加服务列（billType=3账单可选的附加服务，全部仓库并集）
     * @type {Array<CommissionRateServiceVo>}
     * @memberof RecommendCodeBindDetailRespVo
     */
    serviceColumns?: Array<CommissionRateServiceVo>;
    /**
     * 订单明细行列表，按出库日期升序
     * @type {Array<OrderItemVo1>}
     * @memberof RecommendCodeBindDetailRespVo
     */
    orders?: Array<OrderItemVo1>;
    /**
     * 合计--附加服务金额（小计列合计）
     * @type {number}
     * @memberof RecommendCodeBindDetailRespVo
     */
    totalServiceAmount?: number;
    /**
     * 合计--分成金额（业绩列合计）
     * @type {number}
     * @memberof RecommendCodeBindDetailRespVo
     */
    totalCommissionAmount?: number;
}

/**
 * Check if a given object implements the RecommendCodeBindDetailRespVo interface.
 */
export function instanceOfRecommendCodeBindDetailRespVo(value: object): value is RecommendCodeBindDetailRespVo {
    return true;
}

export function RecommendCodeBindDetailRespVoFromJSON(json: any): RecommendCodeBindDetailRespVo {
    return RecommendCodeBindDetailRespVoFromJSONTyped(json, false);
}

export function RecommendCodeBindDetailRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendCodeBindDetailRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'serviceColumns': json['serviceColumns'] == null ? undefined : ((json['serviceColumns'] as Array<any>).map(CommissionRateServiceVoFromJSON)),
        'orders': json['orders'] == null ? undefined : ((json['orders'] as Array<any>).map(OrderItemVo1FromJSON)),
        'totalServiceAmount': json['totalServiceAmount'] == null ? undefined : json['totalServiceAmount'],
        'totalCommissionAmount': json['totalCommissionAmount'] == null ? undefined : json['totalCommissionAmount'],
    };
}

export function RecommendCodeBindDetailRespVoToJSON(json: any): RecommendCodeBindDetailRespVo {
    return RecommendCodeBindDetailRespVoToJSONTyped(json, false);
}

export function RecommendCodeBindDetailRespVoToJSONTyped(value?: RecommendCodeBindDetailRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'serviceColumns': value['serviceColumns'] == null ? undefined : ((value['serviceColumns'] as Array<any>).map(CommissionRateServiceVoToJSON)),
        'orders': value['orders'] == null ? undefined : ((value['orders'] as Array<any>).map(OrderItemVo1ToJSON)),
        'totalServiceAmount': value['totalServiceAmount'],
        'totalCommissionAmount': value['totalCommissionAmount'],
    };
}

